import * as Sentry from '@sentry/browser';
Sentry.init({ dsn: 'https://c67743b050714b84a91b28bb57c49d8f@o55209.ingest.sentry.io/5256513' });


$(document).ready(function () {
    $('.burger').click(function () {
        $('.burger').toggleClass('clicked');
        $('.overlay').toggleClass('show');
        $('nav').toggleClass('show');
        $('body').toggleClass('overflow');
    });

    $('.overlay, .close-menu-click').click(function () {
        $('.burger').removeClass('clicked');
        $('.overlay').removeClass('show');
        $('nav').removeClass('show');
        $('body').removeClass('overflow');
    })
})

$(document).ready(function () {
    var navExpand = [].slice.call(document.querySelectorAll('.nav-expand'))
    navExpand.forEach(function (item) {
        item.querySelector('.nav-expand-content').insertAdjacentHTML('afterbegin', '<li class="nav-item"><a class="nav-link nav-back-link" href="javascript:;"><img src="/images/previous.svg" />' + item.childNodes[1].text + '</a></li>')
        item.querySelector('.nav-link').addEventListener('click', function () {
            item.classList.add('active')
        })
        item.querySelector('.nav-back-link').addEventListener('click', function () {
            item.classList.remove('active')
        })
    })

    // ---------------------------------------
    // not-so-important stuff starts here

    var ham = document.getElementById('ham')
    if (ham) {
        ham.addEventListener('click', function () {
            document.body.classList.toggle('nav-is-toggled')
        })
    }

    var ansoegs = [].slice.call(document.querySelectorAll('.menu-btn'))
    ansoegs.forEach(function (item) {
        item.addEventListener('click', function () {
            document.body.classList.toggle('nav-is-toggled')
        })
    })
});



$(document).ready(function () {
    $(window).scroll(function (event) {
        var form = $("#form-container");
        var gap = $("#header").height();
        var belowOffset = $("#below-offset").offset();
        var width = $("#form-wrapper").width();
        var height = $("#ApplicationFormRoot").height();
        var container = $(".header-section").height();

        var scrollTop = $(this).scrollTop();
        if (typeof belowOffset == 'undefined')
            return;
        var below = belowOffset.top - form.height() ;
        if (below < gap)
            below = gap
        if (container > 850) {
            if (scrollTop > below) {
                form.removeClass('fixed').addClass('relative').css('top', height - form.height() + 'px').css("width", width + "px");
            }
            else if (scrollTop > gap) {
                form.removeClass('relative').addClass('fixed').css('top', '0').css("width", width + "px");
            } else {
                form.removeClass('relative').removeClass('fixed').css('top', '0').css("width", width + "px");
            }
        }
     

    });
});
$(document).ready(function () {
    $('.slick').slick({
        slidesToShow: 3,
        arrows: true,
        dots: true,
        autoplay: false,
        swipeToSlide: true,
        autoplaySpeed: 6000,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    dots: false,
                }
            }
        ]
    });
});


window.facebookEvent = function (amount) {
  fbq('track', 'Purchase', { currency: "SEK", value: amount  });
}